import { mapActions } from "vuex";

export default  {
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				let savePost=false
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'autorizaFtn':	
							savePost=true				
							await this.updateDataPost({ 
								data: { 
									data: JSON.parse(this.dataForm[this.namePath].autorizar.cambios),
									route: 'save_all',
									tablaAuditar: true,
									notaDelete: null,
									tablaDelete: [],
									tablaPost: [],
								 }
							 }) 
							if(this.dataForm[this.namePath].autorizar.tabla_delete!==null)
							{
								await this.updateDataPost({state:'tablaDelete', data: JSON.parse(this.dataForm[this.namePath].autorizar.tabla_delete)})
							}	
							await this.pushDataPost({state:'data', data: {autorizar: {id: this.dataForm[this.namePath].autorizar.id}}})
							await this.pushDataPost({state:'tablaDelete', data: 'autorizar'})
						break;
						case 'anularAutorizaFtn' :							
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all',
									tablaAuditar: true,
									notaDelete: null,
									tablaDelete: ['autorizar'],
									tablaPost: ['autorizar'],
								 }
							 }) 
						break;

					}
				}
				await this.save(event.save)

				
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'lenteEditarFtn':
							if(this.indexData!==false)
							{
								//await this.updateDataGet({ index: this.indexData, data: this.dataForm[this.namePath]})
							}
							else
							{
								//let datos= {}
								//datos.list_users = await this.gettersDatalist('list_users', this.dataForm[this.namePath].list_users.name)[0]
								//await this.pushDataGet({ data: datos})
							}							
						break;
						case 'inactivarFtn':
							// await this.spliceDataGet(this.indexData)
						break;

					}
				}
				const await34 = this.getDataGet({route: 'get_autorizar', data: 'autorizar'})
				
				const await30 = this.resetDataIndex()
				const await31 = this.resetGlobal({state: 'openModal'})
				const await32 = this.resetDataForm()
				const await33 = this.resetGlobal({state: 'saveConfig/capa'}) 
				await await30
				await await31
				await await32
				await await33
				await await34
			}
			catch{

			}			
		}		
	},
}
